<section>
  <div class="container-fluid py-4 px-4">
    <div class="row">

      <div class="col-12 col-md-12 col-lg-8">
        <div class="container-fluid container-left">
          <h5 class="heading-1 my-4">Overview</h5>

          <div class="row">
            <div class="col-12 col-md-6 col-lg-6">
              <div class="card">
                <div class="card-header">
                  <h5 class="card-title title-chart">Hotel Occupancy</h5>
                </div>

                <div class="container">
                  <div class="container-fluid container-box-progress" *ngIf="ItemOccupancy">
                    <div class="row">
                      <!-- Header dengan master toggle -->
                      <div class="row header-row" (click)="toggleTotal()" style="cursor: pointer;">
                        <div class="col-5 title-text">
                          {{ ItemOccupancy.name }}
                          <i class="fas ms-2" [class.fa-chevron-down]="!expandedStates[0]" [class.fa-chevron-up]="expandedStates[0]"></i>
                        </div>
                        <div class="col-7 total-text">{{ ItemOccupancy.total_pct}}%</div>
                      </div>

                      <!-- Budget Section (selalu tampil) -->
                      <div class="metric-group">
                        <div class="remarks-text">{{ ItemOccupancy.remark }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="percentage-text" [class]="getPercentageClass(ItemOccupancy.pct_value)">
                            {{ ItemOccupancy.pct_value }}%
                          </span>
                          <span class="value-text">{{ ItemOccupancy.budget_pct }}%</span>
                        </div>
                      </div>
                      
                      
                      <!-- Expandable Sections (hanya tampil jika Total di-expand) -->
                      <div *ngIf="isTotalExpanded">
                        <!-- Last Month Section -->
                        <div class="metric-group">
                          <div class="remarks-text">{{ ItemOccupancy.lm_remarks }}</div>
                          <div class="percentage-value-wrapper">
                            <span class="percentage-text" [class]="getPercentageClass(ItemOccupancy.pct_lm)">
                              {{ ItemOccupancy.pct_lm }}%
                            </span>
                            <span class="value-text">{{ ItemOccupancy.last_month}}%</span>
                          </div>
                        </div>

                        <!-- Last Year Section -->
                        <div class="metric-group">
                          <div class="remarks-text">{{ ItemOccupancy.ly_remarks }}</div>
                          <div class="percentage-value-wrapper">
                            <span class="percentage-text" [class]="getPercentageClass(ItemOccupancy.pct_ly)">
                              {{ ItemOccupancy.pct_ly }}%
                            </span>
                            <span class="value-text">{{ ItemOccupancy.last_year}}%</span>
                          </div>
                        </div>

                        <!-- This Year Section -->
                        <!--<div class="metric-group last-group">
                          <div class="remarks-text">{{ ItemOccupancy.ty_remarks }}</div>
                          <div class="percentage-value-wrapper">
                            <span class="percentage-text" [class]="getPercentageClass(ItemOccupancy.pct_ty)">
                              {{ ItemOccupancy.pct_ty }}%
                            </span>
                            <span class="value-text">{{ ItemOccupancy.this_year}}%</span>
                          </div>
                        </div>-->
                      </div>  
                    </div>
                  </div>
                </div> 
                <div class="card-body">
                  <div class="p-0 custom-overflow">
                    <div class="row">
                      <div class="col-12">
                        <div id="chart">
                          <div *ngIf="isLoadingOccupancy" class="text-center p-4">
                            <div class="spinner-border" role="status">
                              <span class="visually-hidden">Loading occupancy data...</span>
                            </div>
                          </div>

                          <apx-chart *ngIf="!isLoadingOccupancy" [series]="chartOptionsOccupancy.series"
                            [chart]="chartOptionsOccupancy.chart" [colors]="chartOptionsOccupancy.colors"
                            [plotOptions]="chartOptionsOccupancy.plotOptions"
                            [dataLabels]="chartOptionsOccupancy.dataLabels" [legend]="chartOptionsOccupancy.legend"
                            [grid]="chartOptionsOccupancy.grid" [xaxis]="chartOptionsOccupancy.xaxis"
                            [yaxis]="chartOptionsOccupancy.yaxis">
                          </apx-chart>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6">
              <div class="card mt-2 mt-md-0 mt-lg-0">
                <div class="card-header">
                  <h5 class="card-title title-chart">Office Lease</h5>
                </div>
                <div class="container">
                  <div class="container-fluid container-box-progress" *ngIf="ItemOfficeLease">
                    <div class="row">
                      <!-- Header dengan master toggle -->
                      <div class="row header-row" (click)="toggleTotal()" style="cursor: pointer;">
                        <div class="col-5 title-text">
                          {{ ItemOfficeLease.name }}
                          <i class="fas ms-2" [class.fa-chevron-down]="!expandedStates[0]" [class.fa-chevron-up]="expandedStates[0]"></i>
                        </div>
                        <div class="col-7 total-text">{{ ItemOfficeLease.total_pct}}%</div>
                      </div>

                      <!-- Budget Section (selalu tampil) -->
                      <!--<div class="metric-group">
                        <div class="remarks-text">{{ ItemOfficeLease.remark }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="percentage-text" [class]="getPercentageClass(ItemOfficeLease.budget)">
                            {{ ItemOfficeLease.budget }}%
                          </span>
                          <span class="value-text">{{ ItemOfficeLease.from_budget }}%</span>
                        </div>
                      </div>-->
                      <!-- Last Month Section -->
                      <div class="metric-group">
                        <div class="remarks-text">{{ ItemOfficeLease.lm_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="percentage-text" [class]="getPercentageClass(ItemOfficeLease.pct_lm)">
                            {{ ItemOfficeLease.pct_lm }}%
                          </span>
                          <span class="value-text">{{ ItemOfficeLease.last_month}}%</span>
                        </div>
                      </div>
                      
                      <!-- Expandable Sections (hanya tampil jika Total di-expand) -->
                      <div *ngIf="isTotalExpanded">
                        

                        <!-- Last Year Section -->
                        <div class="metric-group">
                          <div class="remarks-text">{{ ItemOfficeLease.ly_remarks }}</div>
                          <div class="percentage-value-wrapper">
                            <span class="percentage-text" [class]="getPercentageClass(ItemOfficeLease.pct_ly)">
                              {{ ItemOfficeLease.pct_ly }}%
                            </span>
                            <span class="value-text">{{ ItemOfficeLease.last_year}}%</span>
                          </div>
                        </div>

                        <!-- This Year Section -->
                        <!--<div class="metric-group last-group">
                          <div class="remarks-text">{{ ItemOfficeLease.ty_remarks }}</div>
                          <div class="percentage-value-wrapper">
                            <span class="percentage-text" [class]="getPercentageClass(ItemOfficeLease.pct_ty)">
                              {{ ItemOfficeLease.pct_ty }}%
                            </span>
                            <span class="value-text">{{ ItemOfficeLease.this_year}}%</span>
                          </div>
                        </div>-->
                      </div>  
                    </div>
                  </div>
                </div> 

                <div class="card-body">
                  <div class="p-0 custom-overflow">
                    <div class="row">
                      <div class="col-12">
                        <div id="chart">
                          <div *ngIf="isLoadingOfficeLease" class="text-center p-4">
                            <div class="spinner-border" role="status">
                              <span class="visually-hidden">Loading office lease data...</span>
                            </div>
                          </div>

                          <apx-chart *ngIf="!isLoadingOfficeLease"
                            [series]="chartOptionsOfficeLease.series" [chart]="chartOptionsOfficeLease.chart"
                            [colors]="chartOptionsOfficeLease.colors"
                            [plotOptions]="chartOptionsOfficeLease.plotOptions"
                            [dataLabels]="chartOptionsOfficeLease.dataLabels" [legend]="chartOptionsOfficeLease.legend"
                            [grid]="chartOptionsOfficeLease.grid" [xaxis]="chartOptionsOfficeLease.xaxis"
                            [yaxis]="chartOptionsOfficeLease.yaxis">
                          </apx-chart>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-12 col-md-6 col-lg-6">
              <div class="card">
                <div class="card-header">
                  <h5 class="card-title title-chart">Golf Membership</h5>
                </div>
                <div class="container">
                  <div class="container-fluid container-box-progress" *ngIf="ItemGolfMember">
                    <div class="row">
                      <!-- Header dengan master toggle -->
                      <div class="row header-row" (click)="toggleTotal()" style="cursor: pointer;">
                        <div class="col-5 title-text">
                          {{ ItemGolfMember.name }}
                          <i class="fas ms-2" [class.fa-chevron-down]="!expandedStates[0]" [class.fa-chevron-up]="expandedStates[0]"></i>
                        </div>
                        <div class="col-7 total-text">{{ ItemGolfMember.total_member}}</div>
                      </div>

                      <!-- Budget Section (selalu tampil) -->
                      <!--<div class="metric-group">
                        <div class="remarks-text">{{ ItemGolfMember.remark }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="percentage-text" [class]="getPercentageClass(ItemOfficeLease.budget)">
                            {{ ItemOfficeLease.budget }}%
                          </span>
                          <span class="value-text">{{ ItemOfficeLease.from_budget }}%</span>
                        </div>
                      </div>-->
                      <!-- Last Month Section -->
                      <div class="metric-group">
                        <div class="remarks-text">{{ ItemGolfMember.lm_remark }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="percentage-text" [class]="getPercentageClass(ItemGolfMember.lm_diff_member)">
                            {{ ItemGolfMember.lm_diff_member }}%
                          </span>
                          <span class="value-text">{{ ItemGolfMember.lm_member}}</span>
                        </div>
                      </div>
                      
                      <!-- Expandable Sections (hanya tampil jika Total di-expand) -->
                      <div *ngIf="isTotalExpanded">
                        

                        <!-- Last Year Section -->
                        <div class="metric-group">
                          <div class="remarks-text">{{ ItemGolfMember.ly_remark }}</div>
                          <div class="percentage-value-wrapper">
                            <span class="percentage-text" [class]="getPercentageClass(ItemGolfMember.ly_diff_member)">
                              {{ ItemGolfMember.ly_diff_member }}%
                            </span>
                            <span class="value-text">{{ ItemGolfMember.ly_member}}</span>
                          </div>
                        </div>

                        <!-- This Year Section -->
                        <!--<div class="metric-group last-group">
                          <div class="remarks-text">{{ ItemGolfMember.ty_remarks }}</div>
                          <div class="percentage-value-wrapper">
                            <span class="percentage-text" [class]="getPercentageClass(ItemOfficeLease.pct_ty)">
                              {{ ItemOfficeLease.pct_ty }}%
                            </span>
                            <span class="value-text">{{ ItemOfficeLease.this_year}}%</span>
                          </div>
                        </div>-->
                      </div>  
                    </div>
                  </div>
                </div>
                

                <div class="card-body">
                  <div class="p-0 d-flex justify-content-center">
                    <div class="row">
                      <div class="col-12">
                        <app-pie-chart></app-pie-chart>
                      </div>
                    </div>
                  </div>

                  <div class="container">
                    <!-- <div class="row my-2">
                      <div class="d-flex">
                        <div class="box-premium"></div>
                        <span class="title-category-pie">Premium</span>
                      </div>
                    </div> -->

                    <!-- <div class="row my-2">
                      <div class="d-flex">
                        <div class="box-deluxe"></div>
                        <span class="title-category-pie">Deluxe</span>
                      </div>
                    </div>

                    <div class="row my-2">
                      <div class="d-flex">
                        <div class="box-super-premium"></div>
                        <span class="title-category-pie">Super Premium</span>
                      </div>
                    </div> -->

                    <div class="row my-2" *ngFor="let category of legendCategories">
                      <div class="col-12">
                        <div class="d-flex align-items-center">
                          <!-- Menggunakan class legend-box + inline background-color -->
                          <div class="legend-box" [style.background-color]="getBoxBackgroundColor(category.key)">
                          </div>
                          <span class="title-category-pie">{{ category.name }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6">
              <div class="card mt-2 mt-md-0 mt-lg-0 h-100">
                <div class="card-header">
                  <h5 class="card-title title-chart">Revenue</h5>
                </div>
                <div class="container">
                  <div class="container-fluid container-box-progress" *ngIf="ItemRevenue" style="padding-bottom: -40px;">
                    <div class="row">
                      <!-- Header dengan master toggle -->
                      <div class="row header-row" (click)="toggleTotal()" style="cursor: pointer;">
                        <div class="col-5 title-text">
                          {{ ItemRevenue.name }}
                          <i class="fas ms-2" [class.fa-chevron-down]="!expandedStates[0]" [class.fa-chevron-up]="expandedStates[0]"></i>
                        </div>
                        <div class="col-7 total-text">{{ ItemRevenue.revenue | rupiah }}</div>
                      </div>
                      <!-- Last Month Section -->
                      <div class="metric-group">
                        <div class="remarks-text">{{ ItemRevenue.lm_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="percentage-text" [class]="getPercentageClass(ItemRevenue.pct_change_from_lm)">
                            {{ ItemRevenue.pct_change_from_lm }}%
                          </span>
                          <span class="value-text">{{ ItemRevenue.last_month_revenue | rupiah }}</span>
                        </div>
                      </div>
                      <!-- Budget Section (selalu tampil) -->
                      <!--<div class="metric-group">
                        <div class="remarks-text">{{ ItemRevenue.remark }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="percentage-text" [class]="getPercentageClass(ItemRevenue.pct_to_budget)">
                            {{ ItemRevenue.pct_to_budget }}%
                          </span>
                          <span class="value-text">{{ ItemRevenue.budget | rupiah }}</span>
                        </div>
                      </div>-->
                      
                      <!-- Expandable Sections (hanya tampil jika Total di-expand) -->
                      <div *ngIf="isTotalExpanded">
                        <!-- Last Year Section -->
                        <div class="metric-group">
                          <div class="remarks-text">{{ ItemRevenue.ly_remarks }}</div>
                          <div class="percentage-value-wrapper">
                            <span class="percentage-text" [class]="getPercentageClass(ItemRevenue.pct_change_from_ly)">
                              {{ ItemRevenue.pct_change_from_ly }}%
                            </span>
                            <span class="value-text">{{ ItemRevenue.last_year_revenue | rupiah }}</span>
                          </div>
                        </div>

                        <!-- This Year Section -->
                        <!--<div class="metric-group last-group">
                          <div class="remarks-text">{{ ItemRevenue.ty_remarks }}</div>
                          <div class="percentage-value-wrapper">
                            <span class="value-text" style="text-align: left;">{{ ItemRevenue.total_ytd | rupiah }}</span>
                            <span class="percentage-text" [class]="getPercentageClass(ItemRevenue.progress_this_year)">
                              {{ ItemRevenue.progress_this_year }}%
                            </span>
                            <span class="value-text">{{ ItemRevenue.yearly_target | rupiah }}</span>
                          </div>
                        </div>-->
                      </div>  
                    </div>
                  </div>
                </div>

                <div class="container">
                  <!--<div class="row mt-4" *ngFor="let item of chartRevenue">
                    <div class="col-8 col-md-8 col-lg-6">

                      <div class="d-flex flex-column align-items-start">
                        <h5 class="box-text-header1 ">
                          <img src="assets/icon-dashboard-revenue/{{ item.icon }}"> {{ item.name }}
                        </h5>
                        <span class="currency">{{ item.revenue | rupiah }}</span>
                      </div>

                    </div>
                    <div class="col-4 col-md-4 col-lg-6 d-flex justify-content-end">

                      <div class="d-flex flex-column align-items-end">
                      
                        <div [ngSwitch]="true">
                          <span *ngSwitchCase="item.pct_budget === 0" class="badge custom-progress-success" style="font-size: 11px; font-family: var(--font-montserrat-bold);">
                            {{ item.pct_budget }}
                          </span>
                          <span *ngSwitchCase="item.pct_budget && item.pct_budget.toString().startsWith('-')"
                            class="badge custom-progress-danger"  style="font-size: 11px; font-family: var(--font-montserrat-bold);">
                            <i class="fas fa-arrow-down fa-md" style="color: var(--color-red-dark)"></i> {{
                            item.pct_budget }}%
                          </span>
                          <span *ngSwitchDefault class="badge custom-progress-success"  style="font-size: 11px; font-family: var(--font-montserrat-bold);">
                            <i class="fas fa-arrow-up fa-md" style="color: var(--color-green-dark)"></i> +{{
                            item.pct_budget }}%
                          </span>
                        </div>

                        <h5 class="title-under-badge">{{ item.budget_remark }}</h5>
                      </div>
                    </div>
                  </div>-->
                  <div class="mb-3 revenue-item-card" *ngFor="let item of chartRevenue; let i = index">
                    <div class="row">
                      <div class="row header-row" (click)="toggleExpand(i)" style="cursor: pointer; padding-top:20px;">
                        <div class="col-5 title-text">
                          <img src="assets/icon-dashboard-revenue/{{ item.icon }}"> {{ item.name }}
                          <i class="fas ms-2" [class.fa-chevron-down]="!expandedStates[i]" [class.fa-chevron-up]="expandedStates[i]"></i>
                        </div>
                        <div class="col-7 total-text">{{ item.revenue | rupiah }}</div>
                      </div>
                      
                      <ng-container *ngIf="item.name === 'Hotel'">
                        <!-- Budget Section (selalu tampil untuk Hotel) -->
                        <div class="metric-group">
                          <div class="remarks-text">{{ item.budget_remark }}</div>
                          <div class="percentage-value-wrapper">
                            <span class="percentage-text" [class]="getPercentageClass(item.pct_budget)">
                              {{ item.pct_budget }}%
                            </span>
                            <span class="value-text">{{ item.budget | rupiah }}</span>
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="item.name !== 'Hotel'">
                        <!-- Last Month Section -->
                        <div class="metric-group">
                          <div class="remarks-text">{{ item.lm_remark }}</div>
                          <div class="percentage-value-wrapper">
                            <span class="percentage-text" [class]="getPercentageClass(item.pct_lm)">
                              {{ item.pct_lm }}%
                            </span>
                            <span class="value-text">{{ item.revenue_lm | rupiah }}</span>
                          </div>
                        </div>
                      </ng-container>

                      <div *ngIf="expandedStates[i]">
                        <ng-container *ngIf="item.name === 'Hotel'">
                          <!-- Last Month Section -->
                          <div class="metric-group">
                            <div class="remarks-text">{{ item.lm_remark }}</div>
                            <div class="percentage-value-wrapper">
                              <span class="percentage-text" [class]="getPercentageClass(item.pct_lm)">
                                {{ item.pct_lm }}%
                              </span>
                              <span class="value-text">{{ item.revenue_lm | rupiah }}</span>
                            </div>
                          </div>
                        </ng-container>
                        <!-- Last Year Section -->
                        <div class="metric-group">
                          <div class="remarks-text">{{ item.ly_remark }}</div>
                          <div class="percentage-value-wrapper">
                            <span class="percentage-text" [class]="getPercentageClass(item.pct_ly)">
                              {{ item.pct_ly }}%
                            </span>
                            <span class="value-text">{{ item.revenue_ly | rupiah }}</span>
                          </div>
                        </div>

                        <div *ngIf="item.name === 'Hotel'" class="metric-group last-group">
                          <div class="remarks-text">{{ item.ty_remark }}</div>
                          <div class="percentage-value-wrapper">
                            <span class="value-text" style="text-align: left;">{{ item.revenue_ytd | rupiah }}</span>
                            <span class="percentage-text" [class]="getPercentageClass(item.pct_ytd)">
                              {{ item.pct_ytd }}%
                            </span>
                            <span class="value-text">{{ item.total_budget | rupiah }}</span>
                          </div>
                        </div>
                      </div>  
                    </div>  
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="col-12 col-md-12 col-lg-4">
        <div class="container-right my-4 my-lg-0 h-100">
          <h5 class="heading-1 my-4">Sales Activities</h5>

          <div class="category-slider-container">
            <div class="category-buttons-wrapper">

              <!-- Category buttons dengan filter -->
              <button class="btn-category-activites" *ngFor="let item of ItemSalesActivites.headers"
                [class.active]="isCategoryActive(item.label)" (click)="onCategoryClick(item.label)">
                <span class="title-header-button">{{ item.value }}</span>
                <span class="title-header-count">{{ item.label }}</span>
              </button>
            </div>
          </div>

          <!-- Filter status info -->
          <div class="filter-status-info my-3" *ngIf="selectedFilter">
            <small class="text-muted">
              <i class="fas fa-filter"></i> {{ getFilterStatusText() }}
              <button class="btn btn-sm btn-clear" (click)="clearFilter()">
                <i class="fas fa-times"></i> Clear
              </button>
            </small>
          </div>

          <!-- Loading indicator -->
          <div class="loading-indicator text-center my-4" *ngIf="isLoading">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>

          <div class="container-fluid container-group-sales" *ngIf="!isLoading">

            <!-- Empty state ketika tidak ada data -->
            <div class="empty-state text-center my-5" *ngIf="getDisplayedData().length === 0">
              <i class="fas fa-inbox fa-3x text-muted mb-3"></i>
              <h6 class="text-muted">No sales activities found</h6>
              <p class="text-muted small">
                <span *ngIf="selectedFilter">Try adjusting your filter or </span>
                <button class="btn btn-link p-0" (click)="clearFilter()" *ngIf="selectedFilter">
                  view all activities
                </button>
              </p>
            </div>

            <!-- Loop melalui data yang sudah di-limit -->
            <div class="container-box-group-sales my-3" *ngFor="let item of getDisplayedData()">
              <div class="row">
                <div class="col-6 col-md-6 col-lg-6">

                  <div [ngSwitch]="true">
                    <span *ngSwitchCase="item.sales_status === 'Hand Over'" class="badge-handover">{{ item.sales_status
                      }}</span>
                    <span *ngSwitchCase="item.sales_status === 'Won'" class="badge-won">{{
                      item.sales_status }}</span>
                    <span *ngSwitchCase="item.sales_status === 'Inquiry'" class="badge-inquiry">{{ item.sales_status
                      }}</span>
                    <span *ngSwitchCase="item.sales_status === 'Lost'" class="badge-lost">{{
                      item.sales_status
                      }}</span>
                    <span *ngSwitchDefault>{{ item.sales_status }}</span>
                  </div>
                  <div class="mt-2">
                    <h5 class="title-name-activity">{{ item.name }}</h5>
                    <h5 class="title-activity-currency">{{ item.amount | rupiah }}</h5>
                  </div>
                </div>
                <div class="col-6 col-md-6 col-lg-6 d-flex align-items-center justify-content-end">
                  <span class="title-date-activity">{{ item.trans_date | dateformat }}</span>
                </div>
              </div>
            </div>

            <!-- Tombol Show More/Less - hanya tampil jika data lebih dari 10 -->
            <button class="btn btn-show-more my-3" *ngIf="shouldShowMoreButton() || showAllData"
              (click)="toggleShowMore()">
              {{ getShowMoreButtonText() }}
            </button>

            <!-- Optional: Menampilkan informasi jumlah data -->
            <div class="data-info text-muted small" *ngIf="getTotalDataCount() > displayLimit">
              Showing {{ getDisplayedDataCount() }} of {{ getTotalDataCount() }} items
            </div>

          </div>
        </div>


        <div class="container-right my-4 d-none">
          <h5 class="heading-1 my-4">Upcoming Event</h5>

          <div class="container-box-event-list">
            <div class="event-list">

              <div class="event-item">
                <div class="event-calendar">
                  <span class="day">29</span>
                  <span class="month">SEP</span>
                </div>
                <div class="event-details">
                  <span class="category">LMAC</span>
                  <h5 class="title text-truncate-multiline">LMAC Super Hitz Fest</h5>
                </div>
              </div>

              <div class="event-item active">
                <div class="event-calendar">
                  <span class="day">30</span>
                  <span class="month">SEP</span>
                </div>
                <div class="event-details">
                  <span class="category">Hotel</span>
                  <h5 class="title text-truncate-multiline">Wedding at Ballroom Park Hyatt</h5>
                </div>
              </div>

              <div class="event-item">
                <div class="event-calendar">
                  <span class="day">1</span>
                  <span class="month">OCT</span>
                </div>
                <div class="event-details">
                  <span class="category">Office Lease</span>
                  <h5 class="title text-truncate-multiline">Lido Adventure Park - Google Team</h5>
                </div>
              </div>

              <div class="event-item">
                <div class="event-calendar">
                  <span class="day">20</span>
                  <span class="month">OCT</span>
                </div>
                <div class="event-details">
                  <span class="category">Office Lease</span>
                  <h5 class="title text-truncate-multiline">Park Tower - Workshop Microsoft Corporate </h5>
                </div>
              </div>

              <div class="event-item">
                <div class="event-calendar">
                  <span class="day">20</span>
                  <span class="month">OCT</span>
                </div>
                <div class="event-details">
                  <span class="category">Office Lease</span>
                  <h5 class="title text-truncate-multiline">Park Tower - Workshop Microsoft Corporate </h5>
                </div>
              </div>

              <button class="btn btn-show-more my-3">
                Show More
              </button>

            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</section>
